import React from 'react';
import { Button } from 'antd';

const ButtonGroup = Button.Group;

export default class PhaseSwitcher extends React.Component {

    createButtons = () =>{
        let buttons = [];
        const details = JSON.parse(this.props.detail);

        for( var detail of details){
            buttons.push(<Button id={detail.id} key={detail.id} size="large" >{detail.text}</Button>)
        }

        return buttons;
    }

    render() {
        let margin = this.props.left || "20%";
        return <div style={{marginLeft: margin}}>
                <ButtonGroup>
                    {this.createButtons()}
                </ButtonGroup>
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/components/phaseSwitcher.js